import { combineReducers } from 'redux';
import practitioners from './practitioners.reducer';
import patients from './patients.reducer';
import consultations from './consultations.reducer';
import statistics from './statistics.reducer';
import users from './users.reducer';
import languages from "./Languages.reducer";
import specialties from "./specialties.reducer";
import conventions from "./convention.reducer";
import pharmacies from "./pharmacies.reducer"
import providers from "./providers.reducer"
import premium from "./Premium.reducer";
export default function createReducer(injectedReducers)
{
    return combineReducers({
        consultations,
        patients,
        practitioners,
        users,
        statistics,
        languages,
        specialties,
        conventions,
        pharmacies,
        providers,
        premium,
        ...injectedReducers,
    })
}


// WEBPACK FOOTER //
// ./src/reducers/index.js